<template>
  <div class="item-cards">
    <a-card class="base-content-item" v-for="(item, index) in dataList" :key="index">
      <!-- Header -->
      <div class="base-content-item-header">
        <div class="text-header">
          <div v-if="getAcptDatetime(item)" class="text-header-date">
            申込日: {{ getAcptDatetime(item) }}
          </div>
          <div v-if="getAcptNo(item)" class="text-header-seri">
            受付番号: {{ getAcptNo(item) }}
          </div>
        </div>
        <div
          class="tag-header"
          v-if="getReserveSts(item) === '3' && !getCancelDateTokyoInn(item)"
        >
          <div class="label label-grey-200 h-5">
            <span class="text-black">手配状況：キャンセル済み</span>
          </div>
        </div>
        <div
          class="tag-header"
          v-if="getReserveSts(item) !== '3' && !getCancelDateTokyoInn(item)"
        >
          <div class="label label-grey-200 h-5 w-full">
            <span class="text-black">手配状況：成立 手配完了</span>
          </div>
          <div
            class="label label-grey-200 h-5 w-full"
            v-if="
              getStatusOrder(item) &&
              checkShowButton(item) &&
              !getCancelDateTokyoInn(item)
            "
          >
            <span class="text-black">{{ getStatusOrder(item) }}</span>
          </div>
        </div>
        <div class="tag-header" v-if="getCancelDateTokyoInn(item)">
          <div class="label label-grey-200 h-5">
            <span class="text-black">手配状況：キャンセル済み</span>
          </div>
        </div>
      </div>

      <!-- Content -->
      <div class="base-content-item-detail">
        <div class="left-content">
          <img :src="getImageUrl(item)" class="thumbnail" />
        </div>
        <div class="right-content">
          <div class="top">
            <div v-if="getCategoryNm(item)" class="label label-grey-200">
              {{ getCategoryNm(item) }}
            </div>
            <div class="item-number">メニューNo. {{ getMenuNo(item) }}</div>
          </div>
          <div class="title text-epip">
            {{ getMenuNm(item) }}
          </div>
          <div class="payment">
            <div class="total-price">合計 ：100000</div>
            <div v-if="getPointGrntNumAmt(item) !== null" class="total-benepo">付与ベネポ：{{ getPointGrntNumAmt(item) }}ポイント</div>
          </div>
          <div class="address">
            <span v-if="getAreaClassNm(item)" class="icon icon-bor-pin"></span>
            <span class="address-text pl-2">{{ getAreaClassNm(item) }}</span>
          </div>
        </div>
      </div>

      <!-- Footer -->
      <div class="base-content-item-footer">
        <div class="action-response">
          <a-button
            class="c-btn btn-white btn-sm mr-2 sm:mr-4"
            @click="gotoBill(getAcptNo(item))"
          >
            <span>領収書を発行する</span>
          </a-button>
          <a-button
            class="c-btn btn-white btn-sm mr-2 sm:mr-4"
            @click="getPublicStayGuide(item)"
            v-show="visibleReceiveMethods.includes(item.acptNo)"
          >
            <span>ご利用案内書を印刷</span>
          </a-button>
        </div>
        <div class="action-view">
          <a-button
            class="c-btn btn-white mr-2 sm:mr-4"
            @click="gotoDetail(getAcptNo(item), getMenuNo(item), item.srvicDiv !== CONST_DATA.SRVIC_DIV.DOMESTIC_STAY)"
          >
            <span>詳細を見る</span>
          </a-button>
          <a-button
            class="c-btn btn-grey"
            @click="gotoReRegister(getAcptNo(item), getMenuNo(item))"
          >
            <span>もう一度申し込む</span>
          </a-button>
        </div>
      </div>
    </a-card>
  </div>
</template>

<script>
import _ from 'lodash'
const PLACEHOLDER_IMG = require('@/assets/images/slide-img-placeholder.png')
import { GET_MENU_BASIC_INFO } from '@/store/modules/menu/actions.js'
import { GET_ORDER_DETAIL } from '@/store/modules/order/actions'
import downLoadMixin from '@/mixins/download.js'

import moment from 'moment'

export default {
  name: 'ItemCards',
  components: {},
  props: ['value'],
  data() {
    return {
      rate: {
        rateAvg: 4.5
      },
      dataList: null,
      visibleReceiveMethods: []
    }
  },
  beforeMount() {
    this.dataList = this.value
    this.loadReceiveMethod()
  },
  watch: {
    value(val) {
      this.dataList = val
      this.loadReceiveMethod()
    },
    visibleReceiveMethods: {
      deep: true,
      handler() {
      }
    }
  },
  methods: {
    loadReceiveMethod() {
      this.dataList.forEach(item => {
        this.getMethodReceive(item)
      })
    },
    getMethodReceive(item) {
      if (item.srvicDiv !== this.CONST_DATA.SRVIC_DIV.DOMESTIC_STAY) {
        const acptNo = item.acptNo
        this.$repositories('order')
          .getOrderInfoPublicStay(acptNo)
          .then(
            // eslint-disable-next-line no-unused-vars
            (response) => {
              const receivingMethod = _.get(response, 'orderPublicStayDetail.acptDtlList[0].stayAcptDtl.usageGuideReceiptDiv', null)
              if (!(+receivingMethod > 0) && receivingMethod !== null) {
                this.visibleReceiveMethods.push(item.acptNo)
              }
            },
            // eslint-disable-next-line no-unused-vars
            (error) => {
              // this.$toasted.error(error?.message)
            }
          )
      }
    },
    async getPublicStayGuide(item) {
      const acptNo = item.acptNo
      const data = {
        // staffNm: 'string'
      }
      this.$repositories('order')
        .getPublicStayGuide(acptNo, data)
        .then(
          (response) => {
            const pdfFilePath = _.get(response, 'pdfFilePath', '')
            downLoadMixin.$_downloadPdfUrlMixin(pdfFilePath)
          },
          (error) => {
            this.$toasted.error(error?.message)
          }
        )
    },
    getImageUrl(item) {
      const imageUrl = _.get(item, 'menuDetailResponse.menuImages[0].imageUrl', null)
      if (imageUrl) {
        return imageUrl
      }
      return PLACEHOLDER_IMG
    },
    getCategoryNm(item) {
      return (
        _.get(item, 'menuInfo.categoryInfomation.catLrgClassNm', '') +
        _.get(item, 'menuInfo.categoryInfomation.catMidClassNm', '') +
        _.get(item, 'menuInfo.categoryInfomation.catSmlClassNm', '')
      )
    },
    getMenuNo(item) {
      return _.get(item, 'menuNo', '')
    },
    getMenuNm(item) {
      return _.get(item, 'menuNm', '')
    },
    getAcptDatetime(item) {
      const time = _.get(item, 'acptDatetime', '')
      const timeJP = time ? moment(time).format('YYYY/MM/DD') : ''
      return timeJP
    },
    getAcptNo(item) {
      return _.get(item, 'acptNo', '')
    },
    getPointGrntNumAmt(item) {
      return _.get(item, 'pointGrntNumAmt', '')
    },
    getAreaClassNm(item) {
      return (
        _.get(item, 'menuInfo.areaInfomation.areaLrgClassNm', '') +
        _.get(item, 'menuInfo.areaInfomation.areaSmlClassNm', '')
      )
    },
    openMap(item) {
      const latitude = _.get(item, 'menuInfo.areaInfomation.latitude', '')
      const longitude = _.get(item, 'menuInfo.areaInfomation.longitude', '')
      if (latitude && longitude) {
        window.open(`https://maps.google.com/?q=${latitude},${longitude}`)
      }
    },
    async getInfoTokyoInn(item) {
      console.log('item', item)
      let extSystemCd = null
      const menuNo = _.get(item, 'menuNo', '')
      await this.$store.dispatch(GET_MENU_BASIC_INFO, { menuNo }).then(
        (res) => {
          extSystemCd = _.get(res, 'extSystemCd', '')
          console.log('-----------', extSystemCd)
        },
        // eslint-disable-next-line no-unused-vars
        (error) => {
          // this.$toasted.error('メニューとプランはありません。')
        }
      )
      console.log('extSystemCd', extSystemCd)
      if (extSystemCd) {
        return true
      }
      return false
    },
    getCancelDateTokyoInn(item) {
      const cancelDatetime = _.get(item, 'cancelDatetime', null)
      if (cancelDatetime !== null && cancelDatetime !== '') {
        return true
      }
      return false
    },
    getReserveSts(item) {
      return _.get(item, 'reservedSts', '')
    },
    getStatusOrder(item) {
      let checkInDate = null
      let checkOutDate = null
      const today = moment().format('YYYY/MM/DD')
      if (_.get(item, 'checkInDate', '') && _.get(item, 'checkOutDate', '')) {
        checkInDate = moment(_.get(item, 'checkInDate', '')).format('YYYY/MM/DD')
        checkOutDate = moment(_.get(item, 'checkOutDate', '')).format('YYYY/MM/DD')
      }
      if (today < checkInDate) {
        return '利用前'
      }
      if (today > checkOutDate) {
        return '利用済み'
      }
      if (today >= checkInDate && today <= checkOutDate) {
        return '利用中'
      }
    },
    checkShowButton(item) {
      let showButton = true
      if (!_.get(item, 'checkInDate', '') && !_.get(item, 'checkOutDate', '')) {
        showButton = false
      } else {
        showButton = true
      }
      return showButton
    },
    gotoBill(acptNo) {
      const query = {
        acptNo
      }
      this.$router.push({ path: '/mypage/receipt', query })
    },
    gotoReRegister(acptNo, menuNo) {
      this.$store.dispatch(GET_MENU_BASIC_INFO, { menuNo }).then(
        () => {
          this.$store.dispatch(GET_ORDER_DETAIL, acptNo).then(
            (data) => {
              if (data) {
                const planId = _.get(
                  data,
                  'orderStayDetail.acptDtlList[0].acptDtl.planId',
                  ''
                )
                const roomId = _.get(
                  data,
                  'orderStayDetail.acptDtlList[0].acptPrticList[0].stayRoomDayPrticList[0].stayRoomDayPrtic.roomId',
                  ''
                )
                this.$repositories('plan')
                  .getPlanDetail(menuNo, planId, roomId)
                  .then(
                    () => {
                      this.$router.push({
                        path: `/menus/${menuNo}/plans/${planId}/rooms/${roomId}`
                      })
                    },
                    // eslint-disable-next-line no-unused-vars
                    (error) => {
                      this.$router.push({ path: `/menus/${menuNo}` })
                    }
                  )
              }
            },
            // eslint-disable-next-line no-unused-vars
            (error) => {
              this.$router.push({ path: `/menus/${menuNo}` })
            }
          )
        },
        // eslint-disable-next-line no-unused-vars
        (error) => {
          this.$toasted.error('メニューとプランはありません。')
        }
      )
    },
    gotoDetail(acptNo, menuNo, isPublicStay) {
      const query = {
        acptNo,
        isPublicStay
      }
      this.$router.push({ path: `/mypage/orders/${menuNo}`, query })
    }
  }
}
</script>

<style lang="scss" scoped>
@import './styles.scss';
</style>
